import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';

import { useFeatureFlags } from '@/components/providers/FeatureFlagsProvider';
import { incidentsManagementPagerDutyTokensQueries } from '@/lib/queries/integrations/incidentsManagement/pagerduty/tokens';
import { preLoadDefaultProject } from '@/lib/queries/project';

export const Route = createFileRoute('/_root/rca')({
  component: RouteComponent,
  beforeLoad: ({ context: { formatMessage } }) => ({
    title: formatMessage({ id: 'global.breadcrumb.incidents' }),
  }),
  loader: async ({ context }) => {
    const project = await preLoadDefaultProject({ context });

    const tokens = await context.queryClient.ensureQueryData(
      incidentsManagementPagerDutyTokensQueries.list(project.id),
    );

    return { project, tokens };
  },
});

function RouteComponent() {
  const { project } = Route.useLoaderData();
  const { FeaturePagerduty } = useFeatureFlags();

  useSuspenseQuery(incidentsManagementPagerDutyTokensQueries.list(project.id));

  if (FeaturePagerduty !== true) {
    return <Navigate to="/integrations" />;
  }

  return <Outlet />;
}
